import { selectSheetToCloudAlignmentSheetElevation } from "@/store/modes/sheet-to-cloud-alignment-mode-selectors";
import { setSheetElevationForSheetToCloudAlignment } from "@/store/modes/sheet-to-cloud-alignment-mode-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import { View } from "@faro-lotv/app-component-toolbox";
import { useThree } from "@react-three/fiber";
import { useCallback, useState, type JSX } from "react";
import { PerspectiveCamera } from "three";
import { useCameraInCurrentScene } from "../alignment-modes-commons/align-to-cad-utils";
import { CloudElevationScene } from "../alignment-modes-commons/cloud-elevation-scene";
import { useOverlayElements } from "../overlay-elements-context";
import { useCloudForSheetToCloudAlignment } from "./sheet-to-cloud-alignment-mode";

/** @returns The set sheet elevation in cloud scene */
export function SheetToCloudElevationScene(): JSX.Element {
  const pointCloud = useCloudForSheetToCloudAlignment();

  const { singleScreen } = useOverlayElements();
  const background = useThree((s) => s.scene.background);

  const [camera] = useState<PerspectiveCamera>(() => new PerspectiveCamera());
  useCameraInCurrentScene(camera);

  const dispatch = useAppDispatch();

  const sheetElevation = useAppSelector(
    selectSheetToCloudAlignmentSheetElevation,
  );

  const updateSheetElevation = useCallback(
    (elevation: number) => {
      dispatch(setSheetElevationForSheetToCloudAlignment(elevation));
    },
    [dispatch],
  );

  return (
    <View
      camera={camera}
      trackingElement={singleScreen}
      background={background}
      hasSeparateScene
    >
      <CloudElevationScene
        pointCloud={pointCloud}
        cloudElevation={sheetElevation}
        updateCloudElevation={updateSheetElevation}
        camera={camera}
      />
    </View>
  );
}
